import Form from 'react-bootstrap/Form'
import MutedText from 'shared/forms/muted-text'

function ExcludePcard({ params, setParams }) {
  const checked = params.excludePcard === true
  return (
    <>
      <Form.Check
        inline
        checked={checked}
        label="Exclude PCard Vendors"
        name="exclude-pcard"
        type={'checkbox'}
        onChange={() =>
          setParams({ ...params, excludePcard: !params.excludePcard })
        }
        id={'exclude-pcard-checkbox'}
      />
      <MutedText as="div" className="ms-4">
        Exclude vendors that come from PCard file
      </MutedText>
    </>
  )
}

export default ExcludePcard
